import React from "react"
import {
  cls3,
  cls4,
  cls5,
  cls6,
  cls7,
  cls8,
  cls9,
  cls10,
  cls11,
} from "./Data.module.scss"

//<pattern id="New_Pattern_2" data-name="New Pattern 2" width="16" height="19" patternUnits="userSpaceOnUse" viewBox="0 0 16 19"><rect class={cls1} width="16" height="19"/><polygon class={cls2} points="16 22.18 10.5 19 16 15.82 21.5 19 16 22.18"/><polygon class={cls2} points="0 22.18 -5.5 19 0 15.82 5.5 19 0 22.18"/><polygon class={cls2} points="8 12.68 2.5 9.5 8 6.33 13.5 9.5 8 12.68"/><polygon class={cls2} points="16 3.17 10.5 0 16 -3.17 21.5 0 16 3.17"/><polygon class={cls2} points="0 3.17 -5.5 0 0 -3.17 5.5 0 0 3.17"/></pattern></defs>

export const Data = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1495.27 1302.25">
      <g class={cls3}>
        <g id="Layer_2" data-name="Layer 2">
          <g id="shadow" class={cls4}>
            <path
              class={cls5}
              d="M49.32,629.61a23.53,23.53,0,0,0-8-11.62c-3.71-2.87-8.72-5.12-13.55-4.81-2.5.17-4.94.36-7.43.69A24.8,24.8,0,0,0,6,620.94C-2,628.66-2,642.44,6,650.18a24.61,24.61,0,0,0,14.37,7.06c2.49.34,4.93.53,7.43.69l6-.8a16.77,16.77,0,0,0,7.6-4,23.18,23.18,0,0,0,8-11.62A21.13,21.13,0,0,0,49.32,629.61Z"
            />
            <path
              class={cls5}
              d="M959.39,149.26c-5.91-2.09-15.16-1.15-20.35,2.22-2.9,1.88-5.77,4.26-7.33,7.4-2.28,4.61-3.58,11-.22,15.55,2.23,3,3.92,5.07,7.18,6.95a22.18,22.18,0,0,0,7.26,2.54l-.3,0,.88.13.37.06c2.55.45,5.14,1.1,7.68.88,9.09-.77,16.58-6.32,17.85-15.75S968,152.3,959.39,149.26Z"
            />
            <path
              class={cls5}
              d="M508,660.09c-7.68-2.74-16.35-3.64-25.13-3.48a38.15,38.15,0,0,0,7.78-13.79c2.05-6.63,2.17-13.85,2.62-20.75.33-5,1-10.11.73-15.13-.65-13.24-7.69-22.49-18-30a126.24,126.24,0,0,0-34.48-17.55c-11.12-3.73-23.06-4.74-34.72-6.09-12.68-2.32-26.74-8.9-39.07-4.17-13.95,5.35-23.44,18.33-19.24,33.89,7.56,28,40.2,28.73,64.43,31.37a145.64,145.64,0,0,1,20.71,5c1.57.5,3.13,1,4.68,1.63v.16c-2.86,1.13-5.74,2.25-8.62,3.35-33.74,12.8-68.48,22.39-103.47,31.11-21,5.24-43.51,8-59.95,23.5-6.47,6.07-4.74,17.35,2.79,21.66,22.39,12.83,49.51,6.66,73.53,2.85a463.44,463.44,0,0,0,50.53-11.22c-6.61,8.09-11.39,17.54-12.66,27.74-4.75,2.33-7.71,6.93-8.26,12.93.55-6-.54,1.33-.56,3.41a25,25,0,0,0,1.24,7.58c1.7,5.45,5.6,10.15,9.77,14,6.88,6.32,16.63,10.22,25.3,13.26,17.32,6.08,36.72,6.69,54.7,3.82,31.37-5,62.31-29.25,70.46-60.72C538.88,692.23,530.76,668.2,508,660.09Zm-69.85-32.75v0c0,.49-.36,2.46-.1,2.88A3.62,3.62,0,0,1,438.13,627.34Z"
            />
            <path
              class={cls5}
              d="M564.52,1194.34c-8.85-3.58-18-5.08-27.56-5.72-12.24-.82-23.85.88-33.17,9.42-4.36,4-6.41,10.21-6.05,16.1-6.23,1.18-9.58,5.8-8.54,12.37a19,19,0,0,0,3.86,8.3,14.47,14.47,0,0,0,1.53,3.36,12.67,12.67,0,0,0,1.51,2.06c1.55,1.75,1.65,2,.3.83,2.38,5.17,9.84,9.46,15.5,8.89,11.55-1.18,22.49-5.36,33.51-8.82,13.61-4.27,28-6.63,33.25-21.87C582.51,1208.06,574.13,1198.24,564.52,1194.34Z"
            />
            <path
              class={cls5}
              d="M986.93,1206.54c-6.86-19.78-14.56-39.9-27.26-56.73-6.67-8.84-17.28-15.5-28.88-11.75a28.19,28.19,0,0,0-3.21,1.27c-10.14-3.53-23,.16-29.61,8.69a27.6,27.6,0,0,0-4.87,1.47,21.3,21.3,0,0,0-3.11-1c-11.28-2.57-22.67,1.78-28.84,11.74a84.78,84.78,0,0,0-10.09,25c-5.58,1.72-10.55,5.2-13.06,10.58s-4.38,10-5.06,16c-.28,2.46-.49,4.93-.74,7.4a16,16,0,0,0,1.71,8.56c-.07,8,.15,16.07.71,24.12-11.28,3.83-22.4,8.41-31.94,15.12a56.07,56.07,0,0,0-19.2-3.83c-5,0-9.28,6.16-6.1,10.64,4.76,6.74,10.1,13,14,20.25,2.47,4.59,8.76,8.76,14.16,8.12a133.45,133.45,0,0,0,28.22-6.55c8.12-2.76,16.36-5.17,24.65-7.37,17.31-4.59,34.82-8.39,52.26-12.46,17.1-4,34.2-8.18,50.86-13.81,12.48-4.22,26.35-8.86,30.41-23C995.19,1227.67,990.58,1217.05,986.93,1206.54Z"
            />
            <path
              class={cls5}
              d="M757.38,1214.05a40.29,40.29,0,0,0-6.57-2.88c-1.61-.48-3.62-.29-5.42-.47,0-.06-.32-.21-1.34-.5l-3-.85c.27.12.47.23.46.33l-.51-.34-.31-.09-.06-.06.35.13-.63-.4-.17-.18v0c.07-.07-.82-2.07-1-2.64-.05-.18-.26-1-.44-1.65s-.3-1.94-.33-2.21c-.2-1.94-.46-3.86-.72-5.8v-.1c0-.09,0-.21,0-.36,0-.41-.82-6.06-.77-5.83-.2-1.29-.41-2.6-.48-2.81-2.47-8.15-9.15-12.41-17.27-13.15-15.36-1.4-22.36,14.71-23.9,27.06-1.35,10.8-.19,20.86,5,30.59,11,20.33,42.6,34.09,61.38,15.81C771.16,1238.43,769.62,1220.34,757.38,1214.05Z"
            />
            <path class={cls5} d="M741.08,1209.35l-.07,0,0,0Z" />
            <path
              class={cls5}
              d="M737.05,1190.9c0,.16.05.34.09.56C737.5,1193.88,737.32,1192.64,737.05,1190.9Z"
            />
            <path
              class={cls5}
              d="M736.93,1190.13l.12.77C737,1190.41,736.94,1190.17,736.93,1190.13Z"
            />
            <path
              class={cls5}
              d="M1140.34,1185.75c-2.6-8-10.92-16.49-20.16-15.35q-3.21.39-6.4.85,5.55-.8,1.52-.55a35.08,35.08,0,0,0-5.7.38c-6.56.78-12.36,1.45-18.23,4.73-12,6.67-11.92,25,0,31.72,6.2,3.48,12.88,4.3,19.86,4.94,6.52.6,13.86.61,19.5-3.11C1138.22,1204.41,1143.28,1194.83,1140.34,1185.75Z"
            />
            <path
              class={cls5}
              d="M1319.71,1080c-3-5.82-7.83-9.29-14.72-11.3-4-1.17-8.14-2.09-12.2-3.11-8.49-2.11-17-4.14-25.59-5.76-9.15-1.72-18.6-4-27.92-4.06-9.51,0-19.5-.76-28.21,3.71-7.56,3.89-8.12,14.6-2.61,20.29,5.22,5.4,12.58,8,19.66,10.47-3.08,0-6.16,0-9.25,0-.82,0-6.94-.7-5.25-.26-1-.24-2.84-.65-3.51-.76l-2-.84a39.56,39.56,0,0,0-5.29-2.34,25.84,25.84,0,0,0-7.69-.78,14.46,14.46,0,0,0-13.55,10.32c-5.53,17.16,12.11,29.41,26,34.38,12.69,4.57,27.68,4.18,41.07,4.37,13.07.2,26.36-.82,39.05-4.18a119.59,119.59,0,0,0,19.78-7.59c6.88-3.22,14.8-7.58,18-14.88C1329.51,1098.2,1328.82,1086.16,1319.71,1080Z"
            />
            <path
              class={cls5}
              d="M1347.07,942.5c-11-21.53-35.08-33.59-56.85-41.11-21.92-7.57-45.75-10.34-68.85-10.69-17.61-.26-35.73.86-53.09,4.67l-2.08.4c-23.73,4.64-46.57,14.41-65.39,29.65s-32.3,39.85-31.48,64.43c0,.72.09,1.43.16,2.15-8.79,2.81-13,16.21-5.74,23.59,1.62,1.64,3.29,3.23,5,4.79.72.65,7.53,6.3,5.15,4.39,1.27,1,2.53,2,3.79,3a17.43,17.43,0,0,0,4.06,3.77,23.78,23.78,0,0,0,5.17,2.3c.73.38,1.47.74,2.23,1.08a133.91,133.91,0,0,0,31.94,10.18c22,3.77,44.37,4.35,66.65,3.12a605.73,605.73,0,0,0,74.39-8.82c21.89-4,44.86-9.07,63.1-22.52,11.81-8.71,21.38-19.4,26.12-33.56C1355.91,969.69,1353.5,955.06,1347.07,942.5Z"
            />
            <path
              class={cls5}
              d="M694.65,863.67h0C694.44,865,694.54,864.37,694.65,863.67Z"
            />
            <path
              class={cls5}
              d="M953.47,889.31c-12.86-12.38-29.35-21-46.94-27.08-18.55-6.45-38.89-7.58-58.61-8.72l-31.28-1.8c-9.9-.57-19.95-1.63-29.88-1.36-12.59.35-24.73,3.1-35.55,8.85a136.58,136.58,0,0,0-21.16,14.56c-.48-2.86-1.06-5.71-1.75-8.5-1.11-4.52-1.95-5.4-3.75-10-1.31-3.34-2.92-6.77-3.95-10.17-2-6.72-2.31-14.19-1.93-21.14.53-9.45-16.39-11.48-18.86-2.24-2.13,7.94-2.63,15.92-3.18,24-.26,3.79-.85,7.6-1.25,11.39-.21,1.9-.37,3.8-.6,5.7,0,.09-.07.47-.13.84a37.14,37.14,0,0,0-.48,5.65c0,3.76.15,7.5,0,11.26q-.12,2.79-.43,5.57c0,.35-.07.71-.11,1.07s-.4,1.84-.49,2.24c-.42,1.79-.91,3.56-1.51,5.31-.34,1-.74,2-1.12,3l-.25.51c-.33.43-1.49,2.21-1.79,2.68-.87,1.38-1.6,2.81-2.55,4.16-.71,1-1.62,2-2.32,3-.25.3-.48.57-.61.7a86.32,86.32,0,0,1-7,6.37c-2.33,1.91-4.79,3.69-7.24,5.48l-.29.21-.1.06c-1.5,1-3,1.94-4.49,2.88-12.28,7.71-24.89,15-36.48,23.55-12.67,9.31-24.91,21.6-29.83,35.7a31,31,0,0,0,9.65,34.53c7.47,6.16,17.33,9.81,27.38,11.19,41.29,5.7,82.82,2.68,124.19-.4,20-1.49,40.1-3,60.21-3.56,19.55-.56,38.86.47,58.36,1.24,20.92.82,42.81-1,61.24-10.43,16.93-8.69,28.46-22.44,35.7-38.14C988.33,947.07,978.12,913,953.47,889.31Z"
            />
            <path
              class={cls5}
              d="M1131.86,338.05c-6.83-12.88-21.52-13.36-34.08-14.81q-12.58-1.44-25.26-2.05c-4.21-.2-8.43-.38-12.64-.24-3.17.11-6.29.35-9.43.77-6.06.81-10,3.61-14.6,7.4a17.1,17.1,0,0,0-5.49,9.08,17.16,17.16,0,0,0-12.27,6.44,16.18,16.18,0,0,0-1.25,17.73c9,16.35,28.18,19.41,45.15,20.52a126.17,126.17,0,0,0,52.13-8c6.94-2.63,13.18-5.54,17.25-12.18A24.82,24.82,0,0,0,1131.86,338.05Z"
            />
            <path
              class={cls5}
              d="M1356.77,381.59c-22-12.41-44.46-24.17-66.51-36.57-10.86-6.11-21.69-12.3-32.53-18.45-5.27-3-10.5-6.05-15.84-8.9-6.18-3.3-13.23-8.71-20.45-8.1-8.92.77-13.59,8.93-9.77,17,2.95,6.23,10.55,9.44,16.21,12.93,5.15,3.18,10.4,6.19,15.64,9.24,11.08,6.46,22.18,12.88,33.23,19.37,21.8,12.82,43.23,26.27,65,39.09a15.1,15.1,0,0,0,20.31-5.33C1366.1,395,1363.78,385.53,1356.77,381.59Z"
            />
            <path
              class={cls5}
              d="M486.49,1020c0,.12-.07.27-.11.42h0C486.41,1020.3,486.45,1020.16,486.49,1020Z"
            />
            <path
              class={cls5}
              d="M475.78,936.16a119,119,0,0,0-13.15-6.42c7.28-13,11-27.47,6.25-42.84-5.63-18.27-20.12-33-37-41.52a125.38,125.38,0,0,0-27-9.91,98.3,98.3,0,0,0-15.34-2.31,29.32,29.32,0,0,0-14,2.3c-6.54,2.65-10.64,11.27-4.46,16.9,3.08,2.8,5.63,5.2,9.48,6.95,3.53,1.6,6.8,3,10.26,4.62a191.35,191.35,0,0,1,19.4,9.78c3,1.81,6.05,3.62,8.95,5.58.53.35,1.78,1.26,2,1.39,1.12.91,2.21,1.87,3.26,2.86,1.28,1.21,2.47,2.48,3.65,3.77.33.37.57.62.76.82s.33.59.63,1.08c.75,1.24,1.45,2.48,2.14,3.74-.42-.66,1.05,2.6,1.16,3a40.33,40.33,0,0,1,1,3.93c-.14-.48-.1,1.29-.08,2.44a14.06,14.06,0,0,1-.27,2c-.13.53-1,3.05-1.21,3.81-.44.79-1.6,3-1.86,3.48q-1.17,2-2.47,3.92c-.15.22-2,2.74-2,2.91-.4.51-.8,1-1.21,1.51l-1.06-.14c-19.76-2.47-42.42-2.27-60.82,5.76-6.92,3-10.49,13.41-8.26,20.29,2.66,8.22,9.08,12.18,17.33,13.2,5.47.67,11,.23,16.47-.16-7,14.31,7.6,31.07,23.88,22.87,9.11-4.59,17.4-11.54,24.87-19.23,1.22.33,2.44.67,3.65,1s2.65.85,4,1.31c.58.2,3.42,1.31,3.78,1.41a105,105,0,0,1,13.26,7.13c1.41.89,2.76,1.85,4.14,2.78l.55.37a84.21,84.21,0,0,1,6.91,6.18c1.57,1.56,3.05,3.22,4.49,4.9.12.21,1.79,2.33,2,2.65.8,1.19,1.57,2.4,2.3,3.63s1.39,2.61,2.14,3.88c.25.44.45.76.61,1s.18.57.31,1c1.06,3.09,1.8,6.18,2.57,9.35,0,.1.05.19.07.27s0,.49,0,.8c0,1.73,0,3.46,0,5.2,0,.9-.61,2.32-.35,1.31-.33,1.1-.64,2.22-.92,3.32.54-2,.33-.48-.11.41,0,.06,0,.12-.05.17s0-.11.05-.16l-.08.14c-.79,1.37-1.61,2.73-2.39,4.11-.12.2-.21.36-.29.52a1.25,1.25,0,0,0-.17.16c-1.32,1.32-2.5,2.77-3.85,4.06-1,.92-2.06,1.75-3,2.68l-.25.25-.56.37c-2.28,1.54-4.54,3.07-6.91,4.47a172.17,172.17,0,0,1-17.14,8.69l-3.5,1.55c-1,.4-1.91.79-2.87,1.17q-4.5,1.8-9.06,3.43-10.5,3.74-21.26,6.61c-6.55,1.74-13.16,3.21-19.82,4.47-7.34,1.39-12.52,2.21-18.35,2.83a319.57,319.57,0,0,1-46.41,1c-7.2-.28-11.91-.58-17.76-1.85-3.39-.73-6.8-1.34-10.12-2.34-1.34-.4-2.67-1-4-1.37a13.78,13.78,0,0,0-6.63-.13,11.42,11.42,0,0,0-2.39-.67q7.86-3.93,15.4-8.43c11-6.61,25.26-15.19,29.43-27.93,1.95-6-.28-12.09-4.53-16.15l.29.12-1.07-.83c-.41-.34-.83-.67-1.27-1l-1-.77a16.15,16.15,0,0,0-3.32-1.43,15.33,15.33,0,0,0-5-.82c-4.14-.07-7.45,1.13-11.22,2.82a137.35,137.35,0,0,0-13.08,7.19c-8.32,4.89-16.7,9.75-25.34,14.05-3.66,1.82-7.37,3.52-11.1,5.17.57-.27-4.12,1.68-4.73,1.92-2.32.9-4.65,1.75-7,2.58a219.25,219.25,0,0,1-27.8,7.7c-4.16.87-8.34,1.66-12.54,2.32.17-.05-3.45.43-4.26.52-2.76.28-5.51.5-8.27.66a183.5,183.5,0,0,1-28.52-.53c-.69-.07-4.19-.49-4.28-.48q-3.13-.46-6.25-1c-4.82-.89-9.62-1.88-14.37-3.11q-6.19-1.62-12.25-3.71-3.45-1.2-6.84-2.55l-2.54-1-2.33-1a146.68,146.68,0,0,1-26.28-15.07,112.92,112.92,0,0,0-13.64-8.11c-3.85-2-13-2.59-15.54,2.53s-2.29,9.82.39,15a53,53,0,0,0,9,13.21c7.18,7.36,16.06,13.64,24.71,19.14a157.71,157.71,0,0,0,56.13,21.52c42.71,7.59,84.69,1.14,124.38-15.77,1.43-.62,2.86-1.24,4.29-1.88-1.87,3.26-1.84,7.61,1.49,11.43a10.93,10.93,0,0,0,.83.87c0,.14,0,.3.1.52.87,3.64,3.38,6.15,6.32,8.21a58.15,58.15,0,0,0,9,5c7.57,3.54,15.65,5.38,23.86,6.68a239.34,239.34,0,0,0,48.36,2.6,277.84,277.84,0,0,0,94.76-21.07c14.55-6.07,28.55-12.73,40.53-23.2a60.87,60.87,0,0,0,20.84-42.88C527,981.07,502.74,951.47,475.78,936.16Z"
            />
            <path
              class={cls5}
              d="M487.41,1016.7c.11-.38.21-.77.33-1.13C487.57,1016.1,487.46,1016.47,487.41,1016.7Z"
            />
          </g>
          <g id="lineart">
            <polyline
              class={cls6}
              points="743.55 718.14 761.6 735.92 779.64 697.31 797.68 715.09 815.73 676.47 833.77 694.25"
            />
            <path
              class={cls7}
              d="M427.35,537.48v64.24L265,695.45V367.06l162.32-93.73V537.48Zm-31.28,12V503.26L296.3,560.87v46.28Zm0-71.16V432.08L296.3,489.69V536Zm-9-117.83a17.36,17.36,0,0,0,7.85-13.6c0-5-3.52-7-7.85-4.53s-7.83,8.6-7.83,13.59S382.74,363,387.07,360.53Zm0,41.93a17.38,17.38,0,0,0,7.85-13.61c0-5-3.52-7-7.85-4.54a17.4,17.4,0,0,0-7.83,13.61C379.24,402.93,382.74,405,387.07,402.46Zm-31.73,7.85V371.2c0-5-2.27-8-5.53-8a7.48,7.48,0,0,0-3.63,1.09C341.13,367.19,337,375,337,381.76v39.11c0,6.76,4.09,9.85,9.14,6.93S355.34,417.06,355.34,410.31Zm-50-2.55a17.37,17.37,0,0,0,7.83-13.6c0-5-3.5-7.05-7.83-4.53a17.31,17.31,0,0,0-7.87,13.59C297.44,408.22,301,410.25,305.31,407.76Zm0,41.91c4.33-2.5,7.83-8.6,7.83-13.59s-3.5-7-7.83-4.54a17.33,17.33,0,0,0-7.87,13.6C297.44,450.15,301,452.17,305.31,449.67Z"
            />
            <polygon
              class={cls8}
              points="427.35 273.33 265.02 367.06 134.68 292.67 297 198.96 427.35 273.33"
            />
            <polygon points="396.07 503.26 396.07 549.52 296.3 607.15 296.3 560.87 396.07 503.26" />
            <polygon points="396.07 432.08 396.07 478.37 296.3 535.97 296.3 489.69 396.07 432.08" />
            <path
              class={cls8}
              d="M394.92,346.93a17.36,17.36,0,0,1-7.85,13.6c-4.33,2.5-7.83.48-7.83-4.54s3.5-11.09,7.83-13.59S394.92,341.93,394.92,346.93Z"
            />
            <path
              class={cls8}
              d="M394.92,388.85a17.38,17.38,0,0,1-7.85,13.61c-4.33,2.5-7.83.47-7.83-4.54a17.4,17.4,0,0,1,7.83-13.61C391.4,381.83,394.92,383.85,394.92,388.85Z"
            />
            <path d="M355.34,371.2v39.11c0,6.75-4.09,14.58-9.16,17.49s-9.14-.17-9.14-6.93V381.76c0-6.73,4.09-14.57,9.14-17.49a7.48,7.48,0,0,1,3.63-1.09C353.07,363.18,355.34,366.17,355.34,371.2Z" />
            <path
              class={cls8}
              d="M313.14,394.16a17.37,17.37,0,0,1-7.83,13.6c-4.35,2.49-7.87.46-7.87-4.54a17.31,17.31,0,0,1,7.87-13.59C309.64,387.11,313.14,389.14,313.14,394.16Z"
            />
            <path
              class={cls8}
              d="M313.14,436.08c0,5-3.5,11.09-7.83,13.59s-7.87.48-7.87-4.53a17.33,17.33,0,0,1,7.87-13.6C309.64,429,313.14,431.06,313.14,436.08Z"
            />
            <path
              class={cls8}
              d="M265,367.06V695.45L151,630.38l-16.33-9.31V292.67ZM227.65,593.17V556.09c0-7.89-4.81-17.06-10.72-20.46L181.5,515.16c-5.91-3.4-10.71.22-10.71,8.11v37.08c0,7.88,4.8,17,10.71,20.47l35.43,20.45C222.84,604.69,227.65,601.06,227.65,593.17Z"
            />
            <path d="M227.65,556.09v37.08c0,7.89-4.81,11.52-10.72,8.1L181.5,580.82c-5.91-3.42-10.71-12.59-10.71-20.47V523.27c0-7.89,4.8-11.51,10.71-8.11l35.43,20.47C222.84,539,227.65,548.2,227.65,556.09Zm-18.12,7.57c0-7-4.92-15.49-11-19s-11-.66-11,6.33a24.25,24.25,0,0,0,11,19C204.61,573.47,209.53,570.63,209.53,563.66Z" />
            <path
              class={cls8}
              d="M198.57,544.66c6,3.51,11,12,11,19s-4.92,9.81-11,6.32a24.25,24.25,0,0,1-11-19C187.6,544,192.52,541.17,198.57,544.66Z"
            />
            <polyline
              class={cls6}
              points="134.68 621.07 134.68 420.97 134.68 401.44 134.68 292.67 297 198.96"
            />
            <path
              class={cls6}
              d="M313.14,394.16a17.37,17.37,0,0,1-7.83,13.6c-4.35,2.49-7.87.46-7.87-4.54a17.31,17.31,0,0,1,7.87-13.59C309.64,387.11,313.14,389.14,313.14,394.16Z"
            />
            <path
              class={cls6}
              d="M313.14,436.08c0,5-3.5,11.09-7.83,13.59s-7.87.48-7.87-4.53a17.33,17.33,0,0,1,7.87-13.6C309.64,429,313.14,431.06,313.14,436.08Z"
            />
            <path
              class={cls6}
              d="M394.92,346.93a17.36,17.36,0,0,1-7.85,13.6c-4.33,2.5-7.83.48-7.83-4.54s3.5-11.09,7.83-13.59S394.92,341.93,394.92,346.93Z"
            />
            <path
              class={cls6}
              d="M394.92,388.85a17.38,17.38,0,0,1-7.85,13.61c-4.33,2.5-7.83.47-7.83-4.54a17.4,17.4,0,0,1,7.83-13.61C391.4,381.83,394.92,383.85,394.92,388.85Z"
            />
            <path
              class={cls6}
              d="M346.18,427.8c-5.05,2.92-9.14-.17-9.14-6.93V381.76c0-6.73,4.09-14.57,9.14-17.49a7.48,7.48,0,0,1,3.63-1.09c3.26,0,5.53,3,5.53,8v39.11C355.34,417.06,351.25,424.89,346.18,427.8Z"
            />
            <polygon
              class={cls6}
              points="396.07 478.37 296.3 535.97 296.3 489.69 396.07 432.08 396.07 478.37"
            />
            <polygon
              class={cls6}
              points="396.07 549.52 296.3 607.15 296.3 560.87 396.07 503.26 396.07 549.52"
            />
            <polygon
              class={cls6}
              points="427.35 273.33 427.35 467.4 427.35 484.83 427.35 537.48 427.35 601.72 265.02 695.45 265.02 367.06 427.35 273.33"
            />
            <line class={cls6} x1="297" y1="198.96" x2="427.35" y2="273.33" />
            <line
              class={cls6}
              x1="134.68"
              y1="292.67"
              x2="265.03"
              y2="367.06"
            />
            <polyline
              class={cls6}
              points="134.68 621.07 151.01 630.38 265.02 695.45"
            />
            <path
              class={cls6}
              d="M187.6,551a24.25,24.25,0,0,0,11,19c6,3.49,11,.65,11-6.32s-4.92-15.49-11-19S187.6,544,187.6,551Z"
            />
            <path
              class={cls6}
              d="M216.93,601.27,181.5,580.82c-5.91-3.42-10.71-12.59-10.71-20.47V523.27c0-7.89,4.8-11.51,10.71-8.11l35.43,20.47c5.91,3.4,10.72,12.57,10.72,20.46v37.08C227.65,601.06,222.84,604.69,216.93,601.27Z"
            />
            <polygon
              class={cls8}
              points="318.47 556.19 327.82 550.79 327.82 562.73 318.47 568.13 318.47 556.19"
            />
            <polygon
              class={cls9}
              points="334.06 547.19 343.4 541.79 343.4 553.74 334.06 559.13 334.06 547.19"
            />
            <polygon
              class={cls8}
              points="349.65 538.19 358.99 532.79 358.99 544.74 349.65 550.13 349.65 538.19"
            />
            <polygon
              class={cls8}
              points="365.23 529.19 374.58 523.79 374.58 535.74 365.23 541.13 365.23 529.19"
            />
            <polygon
              class={cls9}
              points="380.82 520.19 389.83 514.99 389.83 526.93 380.82 532.13 380.82 520.19"
            />
            <polygon
              class={cls8}
              points="389.83 534.14 389.83 546.08 380.82 551.28 380.82 539.34 389.83 534.14"
            />
            <polygon
              class={cls8}
              points="374.58 554.88 365.23 560.28 365.23 548.34 374.58 542.94 374.58 554.88"
            />
            <polygon
              class={cls9}
              points="358.99 563.88 349.65 569.28 349.65 557.34 358.99 551.94 358.99 563.88"
            />
            <polygon
              class={cls8}
              points="343.4 572.88 334.06 578.28 334.06 566.34 343.4 560.94 343.4 572.88"
            />
            <polygon
              class={cls9}
              points="327.82 581.88 318.47 587.28 318.47 575.34 327.82 569.94 327.82 581.88"
            />
            <polygon
              class={cls9}
              points="303.22 576.94 303.22 565 312.23 559.79 312.23 571.73 303.22 576.94"
            />
            <polygon
              class={cls8}
              points="303.22 584.14 312.23 578.94 312.23 590.88 303.22 596.09 303.22 584.14"
            />
            <polygon
              class={cls8}
              points="318.47 485 327.82 479.6 327.82 491.54 318.47 496.94 318.47 485"
            />
            <polygon
              class={cls9}
              points="334.06 476 343.4 470.6 343.4 482.54 334.06 487.94 334.06 476"
            />
            <polygon
              class={cls8}
              points="349.65 467 358.99 461.6 358.99 473.54 349.65 478.94 349.65 467"
            />
            <polygon
              class={cls8}
              points="365.23 458 374.58 452.6 374.58 464.54 365.23 469.94 365.23 458"
            />
            <polygon
              class={cls9}
              points="380.82 449 389.83 443.79 389.83 455.74 380.82 460.94 380.82 449"
            />
            <polygon
              class={cls8}
              points="389.83 462.94 389.83 474.89 380.82 480.09 380.82 468.15 389.83 462.94"
            />
            <polygon
              class={cls9}
              points="374.58 483.69 365.23 489.09 365.23 477.15 374.58 471.75 374.58 483.69"
            />
            <polygon
              class={cls8}
              points="358.99 492.69 349.65 498.09 349.65 486.15 358.99 480.75 358.99 492.69"
            />
            <polygon
              class={cls8}
              points="343.4 501.69 334.06 507.09 334.06 495.15 343.4 489.75 343.4 501.69"
            />
            <polygon
              class={cls9}
              points="327.82 510.69 318.47 516.09 318.47 504.15 327.82 498.75 327.82 510.69"
            />
            <polygon
              class={cls8}
              points="303.22 505.75 303.22 493.8 312.23 488.6 312.23 500.54 303.22 505.75"
            />
            <polygon
              class={cls8}
              points="303.22 512.95 312.23 507.75 312.23 519.69 303.22 524.9 303.22 512.95"
            />
            <path
              class={cls10}
              d="M420.9,588.42a75.54,75.54,0,1,1-4.29.12Q418.73,588.42,420.9,588.42Zm42.7,94.45c-2.88-25-20.28-53-41.32-65.2-20.4,11.78-37.38,38.49-41,62.93.48.29,1,.58,1.45.86C404.92,694.28,440.42,694.76,463.6,682.87Z"
            />
            <path
              class={cls8}
              d="M463.6,682.87l-41.32-23.1h0V617.67C443.32,629.82,460.72,657.84,463.6,682.87Z"
            />
            <path
              class={cls7}
              d="M422.28,659.77l41.32,23.1c-23.18,11.89-58.68,11.41-80.88-1.41-.49-.28-1-.57-1.45-.86l41-20.84h0Z"
            />
            <path d="M422.28,617.67v42.09h0l-41,20.84C384.9,656.16,401.88,629.45,422.28,617.67Z" />
            <path
              class={cls6}
              d="M391.41,594.4a75.53,75.53,0,1,0,29.49-6q-2.17,0-4.29.12A75.2,75.2,0,0,0,391.41,594.4Z"
            />
            <path
              class={cls6}
              d="M422.28,617.67c-20.4,11.78-37.38,38.49-41,62.93.48.29,1,.58,1.45.86,22.2,12.82,57.7,13.3,80.88,1.41C460.72,657.84,443.32,629.82,422.28,617.67Z"
            />
            <line
              class={cls6}
              x1="422.28"
              y1="617.67"
              x2="422.28"
              y2="659.76"
            />
            <polyline
              class={cls6}
              points="463.61 682.87 422.28 659.77 422.28 659.76 422.27 659.76 381.27 680.6"
            />
            <path
              class={cls9}
              d="M1386.86,594c17.18,41.62,4,86.56-39.68,123l-.64.53a220.19,220.19,0,0,1-30.39,20.94c-22,12.73-47,22.75-73.53,30.07h0V685.68c.13-2.89-1.73-5.81-5.57-8-7.4-4.29-19.44-4.29-26.86,0-3.71,2.13-5.57,5-5.57,7.75V777c-12.83,2.22-25.89,3.88-39.07,5h0c.39-.21.78-.42,1.16-.65,15-8.64,19.84-20.88,14.65-31.88l-10.5-24.54L1143,659.75a46.82,46.82,0,1,0,7.18-93.08,46.63,46.63,0,0,0-19.09,4.06l-24.52-57.29-28.35,66.24c-2.68,5.68-.16,12,7.57,16.47,5.34,3.09,12.24,4.73,19.23,5a47.25,47.25,0,0,0,.42,26.21l-37.76-21.8-51.21,29.56v47.87h0a25.18,25.18,0,1,0,9.83,19.95,23.36,23.36,0,0,0-.21-3.15l41.59,24,19.82-11.44-5.38,12.57a.52.52,0,0,0-.06.13l-10.45,24.42c-5.19,11-.3,23.24,14.66,31.88l.66.38c-54-4.82-105.82-19.22-147.38-43.22a218.38,218.38,0,0,1-29.94-20.58c-.37-.29-.73-.59-1.08-.89-22.58-18.87-37-40-43.32-61.8-7.74-26.77-3.17-54.5,13.7-80.15a139.4,139.4,0,0,1,17-20.92c11.59-11.84,26.13-23,43.62-33.09,3.45-2,7-3.93,10.57-5.79V651.14c0,2.8,1.86,5.61,5.57,7.75,7.42,4.28,19.44,4.28,26.86,0,3.72-2.14,5.56-4.95,5.56-7.75V498.83c102.65-36.58,239-29.19,328,22.21a204.77,204.77,0,0,1,41.6,31.05c12,11.81,21,24.34,27.08,37.25C1385.55,590.87,1386.23,592.42,1386.86,594ZM1309,634V589.29l-38.69-22.35-38.71,22.35V634l38.71,22.34Z"
            />
            <path
              class={cls8}
              d="M1346.54,717.53,1193.73,845.28c-.75.62-1.53,1.24-2.34,1.84a68,68,0,0,1-7,4.6c-31.24,18-81.89,18-113.12,0a67.29,67.29,0,0,1-7-4.6c-.81-.61-1.57-1.22-2.32-1.84L909.6,717.89a218.38,218.38,0,0,0,29.94,20.58c41.56,24,93.43,38.4,147.38,43.22a462.91,462.91,0,0,0,78.63.28c13.18-1.08,26.24-2.74,39.07-5s25.65-5.06,38-8.47c26.58-7.32,51.5-17.34,73.53-30.07A220.19,220.19,0,0,0,1346.54,717.53Z"
            />
            <polygon points="1309.01 589.29 1309.01 633.98 1270.32 656.32 1270.32 611.63 1309.01 589.29" />
            <polygon
              class={cls7}
              points="1309.01 589.29 1270.32 611.63 1231.61 589.29 1270.32 566.94 1309.01 589.29"
            />
            <polygon
              class={cls8}
              points="1270.32 611.63 1270.32 656.32 1231.61 633.98 1231.61 589.29 1270.32 611.63"
            />
            <path
              class={cls8}
              d="M1242.62,685.68c-.11,2.74-2,5.42-5.57,7.48-7.4,4.3-19.44,4.3-26.86,0-3.71-2.14-5.57-4.94-5.57-7.75s1.86-5.62,5.57-7.75c7.42-4.29,19.46-4.29,26.86,0C1240.89,679.87,1242.75,682.79,1242.62,685.68Z"
            />
            <path
              class={cls8}
              d="M1242.62,768.53h0c-12.35,3.41-25.06,6.23-38,8.47v-91.6c0,2.81,1.86,5.61,5.57,7.75,7.42,4.3,19.46,4.3,26.86,0,3.6-2.06,5.46-4.74,5.57-7.48Z"
            />
            <path
              class={cls8}
              d="M1208.23,919.37c45.28,26.13,45.28,68.52,0,94.66s-118.69,26.15-164,0-45.28-68.53,0-94.66a126.81,126.81,0,0,1,19.07-8.92L1062.7,952h0c-.29,9.86,6.07,19.76,19.08,27.27,12.72,7.35,29.4,11,46.08,11s33.34-3.66,46.07-11,19.08-17,19.08-26.6V952l-.61-40.27A122.2,122.2,0,0,1,1208.23,919.37Z"
            />
            <path
              class={cls8}
              d="M1062.7,952l.63-41.53,1-63.33a67.29,67.29,0,0,0,7,4.6c31.23,18,81.88,18,113.12,0a68,68,0,0,0,7-4.6l1,64.59L1193,952v.67c0,9.64-6.35,19.26-19.08,26.6s-29.39,11-46.07,11-33.36-3.66-46.08-11c-13-7.51-19.37-17.41-19.08-27.27Z"
            />
            <path
              class={cls10}
              d="M1150.17,566.67a46.82,46.82,0,1,1-7.18,93.08l-16.5-38.56L1118.87,639v-3.91l-13.44-7.76a46.81,46.81,0,0,1,44.74-60.64Z"
            />
            <path d="M1181.36,749.43c5.19,11,.31,23.24-14.65,31.88-.38.23-.77.44-1.16.65h0a462.91,462.91,0,0,1-78.63-.28l-.66-.38c-15-8.64-19.85-20.88-14.66-31.88L1082.05,725a16.1,16.1,0,0,0-1.28,6.21c0,6.79,4.45,13.51,13.39,18.67,17.86,10.32,46.79,10.32,64.63,0,8.64-5,13.13-11.44,13.39-18a15.88,15.88,0,0,0-1.32-7Z" />
            <path
              class={cls7}
              d="M1170.86,724.89a15.88,15.88,0,0,1,1.32,7c-.26,6.58-4.75,13-13.39,18-17.84,10.32-46.77,10.32-64.63,0-8.94-5.16-13.39-11.88-13.39-18.67a16.1,16.1,0,0,1,1.28-6.21.52.52,0,0,1,.06-.13l5.38-12.57L1118.87,639l7.62-17.79,16.5,38.56Z"
            />
            <path
              class={cls8}
              d="M1106.56,513.44l24.52,57.29A47,47,0,0,0,1105,601.1c-7-.22-13.89-1.86-19.23-5-7.73-4.46-10.25-10.79-7.57-16.47Z"
            />
            <polygon points="1118.87 635.07 1118.87 638.98 1087.49 712.31 1067.67 723.75 1067.67 664.63 1118.87 635.07" />
            <polygon
              class={cls8}
              points="1118.87 635.07 1067.67 664.63 1016.47 635.07 1067.67 605.51 1105.43 627.31 1118.87 635.07"
            />
            <path
              class={cls7}
              d="M1067.67,664.63v59.12l-41.59-24a25.06,25.06,0,0,0-9.62-16.8h0V635.07Z"
            />
            <path
              class={cls8}
              d="M1026.08,699.75a23.36,23.36,0,0,1,.21,3.15,25.38,25.38,0,1,1-.21-3.15Z"
            />
            <path
              class={cls8}
              d="M988.11,498.83V651.14c0,2.8-1.84,5.61-5.56,7.75-7.42,4.28-19.44,4.28-26.86,0-3.71-2.14-5.57-4.95-5.57-7.75V465.35c0,2.82,1.85,5.61,5.57,7.76,7.42,4.29,19.44,4.29,26.86,0,3.59-2.08,5.46-4.76,5.56-7.49Z"
            />
            <path d="M988.11,465.35v.27c-.1,2.73-2,5.41-5.56,7.49-7.42,4.29-19.44,4.29-26.86,0-3.72-2.15-5.57-4.94-5.57-7.76s1.85-5.61,5.57-7.74c7.42-4.29,19.44-4.29,26.86,0C986.27,459.75,988.11,462.55,988.11,465.35Z" />
            <path
              class={cls6}
              d="M1026.08,699.75a23.36,23.36,0,0,1,.21,3.15,25.38,25.38,0,1,1-.21-3.15Z"
            />
            <path
              class={cls6}
              d="M1105.43,627.31a46.82,46.82,0,1,1,44.74,33,47.21,47.21,0,0,1-7.18-.56"
            />
            <path
              class={cls6}
              d="M1131.08,570.73l-24.52-57.29-28.35,66.24c-2.68,5.68-.16,12,7.57,16.47,5.34,3.09,12.24,4.73,19.23,5"
            />
            <path
              class={cls6}
              d="M1082.05,725l-10.45,24.42c-5.19,11-.3,23.24,14.66,31.88l.66.38"
            />
            <path
              class={cls6}
              d="M1165.55,782c.39-.21.78-.42,1.16-.65,15-8.64,19.84-20.88,14.65-31.88l-10.5-24.54L1143,659.75l-16.5-38.56L1118.87,639l-31.38,73.33-5.38,12.57"
            />
            <path
              class={cls6}
              d="M1170.86,724.89a15.88,15.88,0,0,1,1.32,7c-.26,6.58-4.75,13-13.39,18-17.84,10.32-46.77,10.32-64.63,0-8.94-5.16-13.39-11.88-13.39-18.67a16.1,16.1,0,0,1,1.28-6.21.52.52,0,0,1,.06-.13"
            />
            <polygon
              class={cls6}
              points="1270.32 656.32 1231.61 633.98 1231.61 589.29 1270.32 611.63 1309.01 589.29 1309.01 633.98 1270.32 656.32"
            />
            <polyline
              class={cls6}
              points="1231.61 589.29 1270.32 566.94 1309.01 589.29"
            />
            <line
              class={cls6}
              x1="1270.32"
              y1="611.63"
              x2="1270.32"
              y2="656.32"
            />
            <polyline
              class={cls6}
              points="1087.49 712.31 1067.67 723.75 1026.08 699.75"
            />
            <polyline
              class={cls6}
              points="1016.47 682.94 1016.47 635.07 1067.67 664.63 1118.87 635.07 1118.87 638.98"
            />
            <polyline
              class={cls6}
              points="1016.47 635.07 1067.67 605.51 1105.43 627.31 1118.87 635.07"
            />
            <line
              class={cls6}
              x1="1067.67"
              y1="664.63"
              x2="1067.67"
              y2="723.75"
            />
            <path
              class={cls6}
              d="M1193,952.65c0,9.64-6.35,19.26-19.08,26.6s-29.39,11-46.07,11-33.36-3.66-46.08-11c-13-7.51-19.37-17.41-19.08-27.27"
            />
            <path
              class={cls6}
              d="M909.6,717.89,1062,845.28c.75.62,1.51,1.23,2.32,1.84a67.29,67.29,0,0,0,7,4.6c31.23,18,81.88,18,113.12,0a68,68,0,0,0,7-4.6c.81-.6,1.59-1.22,2.34-1.84l152.81-127.75"
            />
            <polyline
              class={cls6}
              points="1064.29 847.12 1063.33 910.45 1062.7 951.98 1062.69 952.65"
            />
            <polyline
              class={cls6}
              points="1191.39 847.12 1192.38 911.71 1192.99 951.98 1193 952.65"
            />
            <path
              class={cls6}
              d="M988.11,498.83c102.65-36.58,239-29.19,328,22.21a204.77,204.77,0,0,1,41.6,31.05c12,11.81,21,24.34,27.08,37.25.72,1.53,1.4,3.08,2,4.62,17.18,41.62,4,86.56-39.68,123l-.64.53a220.19,220.19,0,0,1-30.39,20.94c-22,12.73-47,22.75-73.53,30.07-12.35,3.41-25.06,6.23-38,8.47s-25.89,3.88-39.07,5a462.91,462.91,0,0,1-78.63-.28c-54-4.82-105.82-19.22-147.38-43.22a218.38,218.38,0,0,1-29.94-20.58c-.37-.29-.73-.59-1.08-.89-22.58-18.87-37-40-43.32-61.8-7.74-26.77-3.17-54.5,13.7-80.15a139.4,139.4,0,0,1,17-20.92c11.59-11.84,26.13-23,43.62-33.09,3.45-2,7-3.93,10.57-5.79"
            />
            <path
              class={cls6}
              d="M988.11,465.62c-.1,2.73-2,5.41-5.56,7.49-7.42,4.29-19.44,4.29-26.86,0-3.72-2.15-5.57-4.94-5.57-7.76s1.85-5.61,5.57-7.74c7.42-4.29,19.44-4.29,26.86,0,3.72,2.14,5.56,4.94,5.56,7.74"
            />
            <path
              class={cls6}
              d="M988.11,465.35V651.14c0,2.8-1.84,5.61-5.56,7.75-7.42,4.28-19.44,4.28-26.86,0-3.71-2.14-5.57-4.95-5.57-7.75V465.35"
            />
            <path
              class={cls6}
              d="M1242.62,685.68c-.11,2.74-2,5.42-5.57,7.48-7.4,4.3-19.44,4.3-26.86,0-3.71-2.14-5.57-4.94-5.57-7.75s1.86-5.62,5.57-7.75c7.42-4.29,19.46-4.29,26.86,0C1240.89,679.87,1242.75,682.79,1242.62,685.68Z"
            />
            <polyline
              class={cls6}
              points="1242.62 685.41 1242.62 685.68 1242.62 768.53"
            />
            <line
              class={cls6}
              x1="1204.62"
              y1="777.01"
              x2="1204.62"
              y2="685.41"
            />
            <path
              class={cls6}
              d="M1192.38,911.71a122.2,122.2,0,0,1,15.85,7.66c45.28,26.13,45.28,68.52,0,94.66s-118.69,26.15-164,0-45.28-68.53,0-94.66a126.81,126.81,0,0,1,19.07-8.92"
            />
            <polygon
              class={cls10}
              points="544.54 1180.47 544.54 1222.63 508.02 1243.7 508.02 1201.55 544.54 1180.47"
            />
            <polygon
              class={cls10}
              points="544.54 1180.47 508.02 1201.55 471.51 1180.47 508.02 1159.39 544.54 1180.47"
            />
            <polygon
              class={cls10}
              points="508.02 1201.55 508.02 1243.7 471.51 1222.63 471.51 1180.47 508.02 1201.55"
            />
            <polygon
              class={cls6}
              points="471.51 1180.47 508.02 1159.39 544.54 1180.47 508.02 1201.55 471.51 1180.47"
            />
            <line
              class={cls6}
              x1="508.02"
              y1="1201.55"
              x2="508.02"
              y2="1243.7"
            />
            <polyline
              class={cls6}
              points="471.51 1180.47 471.51 1222.63 508.02 1243.7 544.54 1222.63 544.54 1180.47"
            />
            <polygon
              class={cls7}
              points="925.23 1180.45 925.23 1227.04 884.37 1250.62 884.37 1204.04 925.23 1180.45"
            />
            <polygon
              class={cls8}
              points="925.23 1134 925.23 1180.45 884.37 1204.04 884.37 1157.58 925.23 1134"
            />
            <polygon
              class={cls7}
              points="925.23 1085.5 925.23 1134 884.37 1157.58 884.37 1109.08 925.23 1085.5"
            />
            <polygon points="925.23 1085.5 884.37 1109.08 846.07 1086.97 886.92 1063.37 925.23 1085.5" />
            <polygon
              class={cls9}
              points="886.92 1063.37 846.07 1086.97 802.65 1061.9 843.52 1038.31 886.92 1063.37"
            />
            <polygon
              class={cls8}
              points="884.37 1204.04 884.37 1250.62 843.51 1274.21 843.51 1227.64 884.37 1204.04"
            />
            <polygon points="884.37 1157.58 884.37 1204.04 843.51 1227.64 843.51 1181.19 884.37 1157.58" />
            <polygon
              class={cls8}
              points="884.37 1109.08 884.37 1157.58 843.51 1181.19 843.51 1132.68 884.37 1109.08"
            />
            <polygon
              class={cls8}
              points="884.37 1109.08 843.51 1132.68 805.2 1110.56 846.07 1086.97 884.37 1109.08"
            />
            <polygon
              class={cls7}
              points="846.07 1086.97 805.2 1110.56 761.78 1085.5 802.65 1061.9 846.07 1086.97"
            />
            <polygon points="843.52 1038.31 802.65 1061.9 761.78 1038.31 802.65 1014.71 843.52 1038.31" />
            <polygon
              class={cls8}
              points="843.51 1227.64 843.51 1274.21 802.65 1297.79 802.65 1251.23 843.51 1227.64"
            />
            <polygon
              class={cls9}
              points="843.51 1181.19 843.51 1227.64 802.65 1251.23 802.65 1204.77 843.51 1181.19"
            />
            <polygon
              class={cls8}
              points="843.51 1132.68 843.51 1181.19 802.65 1204.77 802.65 1156.26 843.51 1132.68"
            />
            <polygon
              class={cls8}
              points="843.51 1132.68 802.65 1156.26 764.34 1134.15 805.2 1110.56 843.51 1132.68"
            />
            <polygon points="761.78 1085.5 805.2 1110.56 764.34 1134.15 761.79 1132.68 720.92 1109.08 761.78 1085.5" />
            <polygon
              class={cls8}
              points="802.65 1251.23 802.65 1297.79 761.79 1274.21 761.79 1227.64 802.65 1251.23"
            />
            <polygon
              class={cls7}
              points="802.65 1204.77 802.65 1251.23 761.79 1227.64 761.79 1181.19 802.65 1204.77"
            />
            <polygon
              class={cls8}
              points="802.65 1156.26 802.65 1204.77 761.79 1181.19 761.79 1135.62 764.34 1134.15 802.65 1156.26"
            />
            <polygon
              class={cls8}
              points="802.65 1061.9 761.78 1085.5 720.92 1061.9 761.78 1038.31 802.65 1061.9"
            />
            <polygon
              class={cls8}
              points="764.34 1134.15 761.79 1135.62 761.79 1132.68 764.34 1134.15"
            />
            <polygon points="761.79 1227.64 761.79 1274.21 720.92 1250.62 720.92 1204.04 761.79 1227.64" />
            <polygon
              class={cls8}
              points="761.79 1181.19 761.79 1227.64 720.92 1204.04 720.92 1157.58 761.79 1181.19"
            />
            <polygon
              class={cls9}
              points="761.79 1135.62 761.79 1181.19 720.92 1157.58 720.92 1109.08 761.79 1132.68 761.79 1135.62"
            />
            <polygon
              class={cls8}
              points="720.92 1061.9 761.78 1085.5 720.92 1109.08 680.07 1085.5 720.92 1061.9"
            />
            <polygon
              class={cls8}
              points="720.92 1157.58 720.92 1204.04 680.07 1180.45 680.07 1134 720.92 1157.58"
            />
            <polygon
              class={cls8}
              points="720.92 1109.08 720.92 1157.58 680.07 1134 680.07 1085.5 720.92 1109.08"
            />
            <polygon
              class={cls6}
              points="680.07 1085.5 720.92 1061.9 761.78 1038.31 802.65 1014.71 843.52 1038.31 886.92 1063.37 925.23 1085.5 884.37 1109.08 843.51 1132.68 802.65 1156.26 764.34 1134.15 761.79 1132.68 720.92 1109.08 680.07 1085.5"
            />
            <polyline
              class={cls6}
              points="802.65 1156.26 802.65 1204.77 802.65 1251.23 802.65 1297.79"
            />
            <polyline
              class={cls6}
              points="720.92 1061.9 761.78 1085.5 805.2 1110.56 843.51 1132.68 843.51 1181.19 843.51 1227.64 843.51 1274.21"
            />
            <polyline
              class={cls6}
              points="761.79 1132.68 761.79 1135.62 761.79 1181.19 761.79 1227.64 761.79 1274.21"
            />
            <polyline
              class={cls6}
              points="761.78 1038.31 802.65 1061.9 846.07 1086.97 884.37 1109.08 884.37 1157.58 884.37 1204.04 884.37 1250.62"
            />
            <polyline
              class={cls6}
              points="843.52 1038.31 802.65 1061.9 761.78 1085.5 720.92 1109.08 720.92 1157.58 720.92 1204.04 720.92 1250.62 761.79 1274.21 802.65 1297.79 843.51 1274.21 884.37 1250.62 925.23 1227.04 925.23 1180.45 925.23 1134 925.23 1085.5"
            />
            <polyline
              class={cls6}
              points="680.07 1134 720.92 1157.58 761.79 1181.19 802.65 1204.77 843.51 1181.19 884.37 1157.58 925.23 1134"
            />
            <polyline
              class={cls6}
              points="680.07 1085.5 680.07 1134 680.07 1180.45 720.92 1204.04 761.79 1227.64 802.65 1251.23 843.51 1227.64 884.37 1204.04 925.23 1180.45"
            />
            <polyline
              class={cls6}
              points="761.79 1135.62 764.34 1134.15 805.2 1110.56 846.07 1086.97 886.92 1063.37"
            />
            <path
              class={cls9}
              d="M922.92,242.58,893.31,320a4.38,4.38,0,0,1-2,3.41l-3.94,2.28-23,13.26-13.76,7.95c2.7-12.49,2.13-27.56-7.48-24.41l-.23.08h0c-10.19,3.6-13.46,22.83-16.92,38.54l-17.9,10.34h0L775,390.61a.21.21,0,0,1-.1,0c-1,.57-1.89,0-1.89-1.19l29.61-77.41a4.33,4.33,0,0,1,2-3.43l28.56-16.49L921,241.44C922,240.82,922.92,241.33,922.92,242.58Z"
            />
            <path
              class={cls8}
              d="M842.94,322.61h0l.23-.08c9.61-3.15,10.18,11.92,7.48,24.41L864.41,339c-15.57,32.73-40.7,38.5-56.29,32.51L826,361.15C829.48,345.44,832.75,326.21,842.94,322.61Z"
            />
            <path
              class={cls8}
              d="M833.17,292.13l-28.56,16.49a4.33,4.33,0,0,0-2,3.43L773,389.46c0,1.21.84,1.76,1.89,1.19L771,392.89a4.66,4.66,0,0,1-4.24-.19l-.24-.14-2.19-1.26-76.86-44.36c-1.25-.74-1.39-1.83-.29-2.46L717,327.26c.15.21.29.45.43.69l1.95,3.47a7.22,7.22,0,0,0,9.19,3.07l12.76-5.6a6.9,6.9,0,0,0,4-5l1.2-5.91a5.27,5.27,0,0,1,5.75-4.18c12.72,1.51,22.2,4,36.1,10a4,4,0,0,0,4-7A178.26,178.26,0,0,0,766,301.65c.14-1,.29-1.94.43-2.92l37.12-21.42a4.7,4.7,0,0,1,4.23.18Z"
            />
            <path
              class={cls9}
              d="M787,887.56c9.22,4.72,28.43,5.58,28.43,18.22,0,12.32-19.65,14.15-31.89,14.15-31.3,0-30.3-12.95-50.21-22.76-8.18-4-19.4-1.42-28.2-3.17a22.18,22.18,0,0,1-12.57-16.93c23.07.53,40.9-6.87,56-27.29C757.25,866.45,771.54,878.81,787,887.56Z"
            />
            <path
              class={cls7}
              d="M729.55,290.64a53.45,53.45,0,0,1,12.77,1.93,168.52,168.52,0,0,1,21.12,7.9c.88.39,1.73.79,2.58,1.18a178.26,178.26,0,0,1,26.36,15.21,4,4,0,0,1-4,7c-13.9-6-23.38-8.52-36.1-10a5.27,5.27,0,0,0-5.75,4.18l-1.2,5.91a6.9,6.9,0,0,1-4,5l-12.76,5.6a7.22,7.22,0,0,1-9.19-3.07L717.47,328c-.14-.24-.28-.48-.43-.69a9.33,9.33,0,0,0-9.25-3.94c-6.33,1.05-17.22,3.66-32.84,10.13-6.36-5.6-11.22-14.21-14.43-30.21a325.53,325.53,0,0,1,32.27-8.68C706.61,291.65,719.25,290.19,729.55,290.64Z"
            />
            <path
              class={cls8}
              d="M776.49,207.11c0,16-2.24,32.33-3.29,49.28-2.14,14-4.62,28.11-6.75,42.34l-3,1.74a168.52,168.52,0,0,0-21.12-7.9,53.45,53.45,0,0,0-12.77-1.93V258.7l-13.37,7.73v-3.07c0-2.62-1.71-3.8-3.91-2.83,4-23.43,7.69-58.78,1.1-94.61-1.85-9-3.46-15.63-9.55-24.89h0l.59-1.29a2.54,2.54,0,0,1,2.75-1.47c12.36,2.06,21.33-1.28,28-8.31C758.26,140.33,776.49,164.76,776.49,207.11Z"
            />
            <path d="M679.51,586.45c-8.1,40.53-17.87,80.85-25.59,121.74,0,0-5.08,30.93-7,83.3s7.19,165.21,7.19,165.21c-6.17-.69-11.84-1.11-17.22-1.29a224.52,224.52,0,0,0-35.9,1.84c-3.41.41-6.93.88-10.62,1.38-16-124.55-1.57-219.09-1.73-284.2-.12-49-4.79-92.48-4.79-140.54,0-64.81,6.65-99.93,12.85-127.5,12.79,17.25,46.58,22.7,66.88,24.51,29.71,1.82,80.11-5,100.83-39.6l2.19,1.26c3.55,34,8.06,72.78,8.06,105.71,0,48.91-9.43,79.23-15.66,122.4-12.65,87.51-8.53,202.06-7.07,224.34-1.09,1.66-2.21,3.25-3.33,4.77-15.08,20.42-32.91,27.82-56,27.29-3.05-.06-6.18-.27-9.41-.6C687.43,827.58,682.79,674.94,679.51,586.45Z" />
            <path
              class={cls8}
              d="M766.45,298.73c-.14,1-.29,1.95-.43,2.92-.85-.39-1.7-.79-2.58-1.18Z"
            />
            <path
              class={cls8}
              d="M687.51,346.94c-1.25-.74-1.39-1.83-.29-2.46L717,327.26a9.33,9.33,0,0,0-9.25-3.94c-6.33,1.05-17.22,3.66-32.84,10.13a35.56,35.56,0,0,0,5.62,4.05c-14.42,17.61-48.28,41.84-83.86,57.14a34.38,34.38,0,0,1-4.63,1.61h0a25.72,25.72,0,0,0,4.58,10.13c12.79,17.25,46.58,22.7,66.88,24.51,19.22,1.18,47.09-1.29,70-12.52-13.62-23.17-27.95-46-41.48-68.82Z"
            />
            <path
              class={cls7}
              d="M764.37,391.3l-72.32-41.74c13.53,22.81,27.86,45.65,41.48,68.82C746,412.24,757.06,403.5,764.37,391.3Z"
            />
            <path d="M761.12,25.39a37.82,37.82,0,0,1-1.24,5.83,36.79,36.79,0,0,1-8.57,15c-9.25,9.55-24.31,13.3-44.55,7.17-2.33-.72-4.67-1.54-7-2.43-2.92,9.43-7.85,20-13.82,30.54-1.94-4.9-5.31-7.88-8.61-8.87-3.78-1.16-7.47.31-8.73,4.48s.69,11.1,3.28,17l-.09,0c-9.36-2.85-14.51-11.55-11.77-20.57a18.41,18.41,0,0,1,1.06-2.7c-5.34-3.2-5.32-11.22-3.49-17.21a23.08,23.08,0,0,1,2.5-5.75,11.78,11.78,0,0,1-1.84-10c1-3.2,3.54-5.89,7.53-7.32a30.3,30.3,0,0,1,1.14-6c3-9.92,9.11-12.71,17-12,4.21-7,13.5-11.19,21.31-8.82a13.67,13.67,0,0,1,7.14,4.89A20.57,20.57,0,0,1,725.23,8C736,11.26,741.1,21.6,751.51,24.76A21.78,21.78,0,0,0,761.12,25.39Z" />
            <path
              class={cls7}
              d="M751.31,46.22c4,22-.19,47.17-4.45,61.21-2.81,9.23-6.56,17-11.75,22.52-6.62,7-15.59,10.37-28,8.31a2.54,2.54,0,0,0-2.75,1.47l-.59,1.29h0a109.86,109.86,0,0,0-4.77,12.49c-17.83-1.32-34.1-10.76-41.18-21,5.9-11,12.43-24.26,16.84-32.85-.92-1.66-1.9-3.59-2.79-5.63-2.59-5.85-4.59-12.65-3.28-17s5-5.64,8.73-4.48c3.3,1,6.67,4,8.61,8.87,6-10.56,10.9-21.11,13.82-30.54,2.29.89,4.63,1.71,7,2.43C727,59.52,742.06,55.77,751.31,46.22Z"
            />
            <path
              class={cls8}
              d="M729.55,258.7v31.94c-10.3-.45-22.94,1-36.76,3.92V279.91l13.38-7.71v-3.06a9.77,9.77,0,0,1,2.42-6,8.1,8.1,0,0,1,2-1.72l1.15-.66c.17-.1.35-.19.52-.27,2.2-1,3.91.21,3.91,2.83v3.07Z"
            />
            <path
              class={cls8}
              d="M713.37,165.92c6.59,35.83,2.88,71.18-1.1,94.61-.17.08-.35.17-.52.27l-1.15.66a8.1,8.1,0,0,0-2,1.72c-30.08-81.19-65.47-89.3-66.7-117.2l5.09-2.42c18.77,21.62,46.25,32.86,46.25,32.86s.31-2.2,1.86-8.36c.87-3.49,2.14-8.22,4-14.53a113.22,113.22,0,0,1,9,6.92c.48.41.93.82,1.37,1.22h0A27.49,27.49,0,0,1,713.37,165.92Z"
            />
            <path
              class={cls8}
              d="M703.82,141c6.09,9.26,7.7,15.84,9.55,24.89a27.49,27.49,0,0,0-3.93-4.24h0c-.44-.4-.89-.81-1.37-1.22a113.22,113.22,0,0,0-9-6.92h0A109.86,109.86,0,0,1,703.82,141Z"
            />
            <path
              class={cls8}
              d="M660.52,303.24c3.21,16,8.07,24.61,14.43,30.21a35.56,35.56,0,0,0,5.62,4.05c-14.42,17.61-48.28,41.84-83.86,57.14A34.22,34.22,0,0,1,549,365.26c-5-79.54,12.48-151.32,44.24-188.06l.12-.14a68.7,68.7,0,0,1,21.89-17.86q13.13-6.8,26.61-13.22c1.23,27.9,36.62,36,66.7,117.2a9.77,9.77,0,0,0-2.42,6v3.06l-13.38,7.71v14.65A325.53,325.53,0,0,0,660.52,303.24Z"
            />
            <path
              class={cls8}
              d="M699.05,153.52h0c-1.82,6.31-3.09,11-4,14.53-1.55,6.16-1.86,8.36-1.86,8.36S665.75,165.18,647,143.56h0a65.12,65.12,0,0,0,10.88-11C665,142.76,681.22,152.2,699.05,153.52Z"
            />
            <path
              class={cls9}
              d="M652.59,1002.55A15,15,0,0,1,645,1022.8a35.83,35.83,0,0,1-14.21,3.15c-9,0-17.65-3.88-25.31-9.71a25.86,25.86,0,0,1-9.57-26.14,230.48,230.48,0,0,0,5-32.84h0a224.52,224.52,0,0,1,35.9-1.84C639.56,972.47,645.16,987.12,652.59,1002.55Z"
            />
            <path
              class={cls6}
              d="M766,301.65c.14-1,.29-1.94.43-2.92,2.13-14.23,4.61-28.37,6.75-42.34,1-16.95,3.29-33.31,3.29-49.28,0-42.35-18.23-66.78-41.38-77.16"
            />
            <path
              class={cls6}
              d="M671.92,94.06l-.09,0c-9.36-2.85-14.51-11.55-11.77-20.57a18.41,18.41,0,0,1,1.06-2.7c-5.34-3.2-5.32-11.22-3.49-17.21a23.08,23.08,0,0,1,2.5-5.75,11.78,11.78,0,0,1-1.84-10c1-3.2,3.54-5.89,7.53-7.32a30.3,30.3,0,0,1,1.14-6c3-9.92,9.11-12.71,17-12,4.21-7,13.5-11.19,21.31-8.82a13.67,13.67,0,0,1,7.14,4.89A20.57,20.57,0,0,1,725.23,8C736,11.26,741.1,21.6,751.51,24.76a21.78,21.78,0,0,0,9.61.63,37.82,37.82,0,0,1-1.24,5.83,36.79,36.79,0,0,1-8.57,15c-9.25,9.55-24.31,13.3-44.55,7.17-2.33-.72-4.67-1.54-7-2.43-2.92,9.43-7.85,20-13.82,30.54-1.94-4.9-5.31-7.88-8.61-8.87-3.78-1.16-7.47.31-8.73,4.48s.69,11.1,3.28,17c.89,2,1.87,4,2.79,5.63-4.41,8.59-10.94,21.88-16.84,32.85"
            />
            <path
              class={cls6}
              d="M647,143.56,641.89,146q-13.51,6.44-26.61,13.22a68.7,68.7,0,0,0-21.89,17.86"
            />
            <path
              class={cls6}
              d="M596.66,406.39c-6.2,27.57-12.85,62.69-12.85,127.5,0,48.06,4.67,91.55,4.79,140.54.16,65.11-14.3,159.65,1.73,284.2,3.69-.5,7.21-1,10.62-1.38a224.52,224.52,0,0,1,35.9-1.84c5.38.18,11,.6,17.22,1.29,0,0-9.16-112.83-7.19-165.21s7-83.26,7-83.3c7.72-40.89,17.49-81.21,25.59-121.74"
            />
            <path
              class={cls6}
              d="M692.58,877.07A22.18,22.18,0,0,0,705.15,894c8.8,1.75,20-.87,28.2,3.17,19.91,9.81,18.91,22.76,50.21,22.76,12.24,0,31.89-1.83,31.89-14.15,0-12.64-19.21-13.5-28.43-18.22-15.48-8.75-29.77-21.11-38.46-37.78"
            />
            <path
              class={cls6}
              d="M601,957.26a230.48,230.48,0,0,1-5,32.84,25.86,25.86,0,0,0,9.57,26.14c7.66,5.83,16.28,9.71,25.31,9.71A35.83,35.83,0,0,0,645,1022.8a15,15,0,0,0,7.57-20.25c-7.43-15.43-13-30.08-15.74-47.14"
            />
            <path
              class={cls6}
              d="M592.08,396.26a25.72,25.72,0,0,0,4.58,10.13c12.79,17.25,46.58,22.7,66.88,24.51,29.71,1.82,80.11-5,100.83-39.6"
            />
            <path
              class={cls6}
              d="M766.56,392.56c3.55,34,8.06,72.78,8.06,105.71,0,48.91-9.43,79.23-15.66,122.4-12.65,87.51-8.53,202.06-7.07,224.34-1.09,1.66-2.21,3.25-3.33,4.77-15.08,20.42-32.91,27.82-56,27.29-3.05-.06-6.18-.27-9.41-.6,4.26-48.89-.38-201.53-3.66-290"
            />
            <path class={cls6} d="M703.82,141a109.86,109.86,0,0,0-4.77,12.49" />
            <path
              class={cls6}
              d="M751.31,46.22c4,22-.19,47.17-4.45,61.21-2.81,9.23-6.56,17-11.75,22.52-6.62,7-15.59,10.37-28,8.31a2.54,2.54,0,0,0-2.75,1.47l-.59,1.29"
            />
            <path
              class={cls6}
              d="M699.05,153.53c-1.82,6.31-3.09,11-4,14.53-1.55,6.16-1.86,8.36-1.86,8.36S665.75,165.18,647,143.56h0a65.12,65.12,0,0,0,10.88-11c7.08,10.22,23.35,19.66,41.18,21"
            />
            <path
              class={cls6}
              d="M709.44,161.68a27.49,27.49,0,0,1,3.93,4.24c-1.85-9-3.46-15.63-9.55-24.89h0"
            />
            <path
              class={cls6}
              d="M699.05,153.52h0a113.22,113.22,0,0,1,9,6.92c.48.41.93.82,1.37,1.22"
            />
            <path
              class={cls6}
              d="M593.39,177.06l-.12.14C561.51,213.94,544.05,285.72,549,365.26a34.22,34.22,0,0,0,47.68,29.38c35.58-15.3,69.44-39.53,83.86-57.14a35.56,35.56,0,0,1-5.62-4.05c-6.36-5.6-11.22-14.21-14.43-30.21"
            />
            <path
              class={cls6}
              d="M583.91,336.71c7.36-4.25,15.29-8.4,23.59-12.38a425.85,425.85,0,0,1,53-21.09,325.53,325.53,0,0,1,32.27-8.68c13.82-2.91,26.46-4.37,36.76-3.92a53.45,53.45,0,0,1,12.77,1.93,168.52,168.52,0,0,1,21.12,7.9c.88.39,1.73.79,2.58,1.18a178.26,178.26,0,0,1,26.36,15.21,4,4,0,0,1-4,7c-13.9-6-23.38-8.52-36.1-10a5.27,5.27,0,0,0-5.75,4.18l-1.2,5.91a6.9,6.9,0,0,1-4,5l-12.76,5.6a7.22,7.22,0,0,1-9.19-3.07L717.47,328c-.14-.24-.28-.48-.43-.69a9.33,9.33,0,0,0-9.25-3.94c-6.33,1.05-17.22,3.66-32.84,10.13"
            />
            <path class={cls6} d="M616,245c-4.09,24.06-6.91,57.41-8.46,79.31" />
            <path
              class={cls6}
              d="M833.17,292.13,807.8,277.49a4.7,4.7,0,0,0-4.23-.18l-37.12,21.42-3,1.74"
            />
            <path
              class={cls6}
              d="M717,327.26l-29.82,17.22c-1.1.63-1,1.72.29,2.46l76.86,44.36,2.19,1.26.24.14a4.66,4.66,0,0,0,4.24.19l3.87-2.24"
            />
            <line
              class={cls6}
              x1="808.12"
              y1="371.49"
              x2="826.02"
              y2="361.15"
            />
            <path
              class={cls6}
              d="M850.65,346.93,864.41,339l23-13.26,3.94-2.28a4.38,4.38,0,0,0,2-3.41l29.61-77.45c0-1.25-.89-1.76-2-1.14l-87.79,50.69-28.56,16.49a4.33,4.33,0,0,0-2,3.43L773,389.46c0,1.21.84,1.76,1.89,1.19a.21.21,0,0,0,.1,0l33.1-19.12"
            />
            <path
              class={cls6}
              d="M808.11,371.49h0c15.59,6,40.72.22,56.29-32.51"
            />
            <path
              class={cls6}
              d="M692.79,294.56V279.91l13.38-7.71v-3.06a9.77,9.77,0,0,1,2.42-6,8.1,8.1,0,0,1,2-1.72l1.15-.66c.17-.1.35-.19.52-.27,2.2-1,3.91.21,3.91,2.83v3.07l13.37-7.73v31.94h0"
            />
            <path
              class={cls6}
              d="M708.59,263.18c-30.08-81.19-65.47-89.3-66.7-117.2h0"
            />
            <path
              class={cls6}
              d="M712.27,260.53c4-23.43,7.69-58.78,1.1-94.61"
            />
            <path
              class={cls6}
              d="M842.94,322.6l.23-.08c9.61-3.15,10.18,11.92,7.48,24.41"
            />
            <path
              class={cls6}
              d="M826,361.15c3.46-15.71,6.73-34.94,16.92-38.54"
            />
            <path
              class={cls6}
              d="M839.41,352.73c.87-5.92,2.35-19.12,3.53-30.12h0"
            />
            <path
              class={cls11}
              d="M676.26,602.35c5.35-25.57,10.23-51.18,13.7-77,17.71-6.38,19.81-18.56,21.41-38.27"
            />
            <path
              class={cls8}
              d="M455.64,955.51c47.93,35.07,37.53,85.93-23.23,113.6s-148.83,21.67-196.76-13.41a100,100,0,0,1-9.36-7.72c42.28-14.45,69.33-41.17,68.72-70.5,7.95-.13,15.82-.64,23.52-1.53v29.66c0,4,2.65,8,7.94,11.06,10.59,6.12,27.77,6.12,38.35,0,5.29-3,7.94-7,7.94-11.06V964a8.93,8.93,0,0,0-.13-1.55c17-7,31.38-16.22,41.76-27.32C429.87,940.13,444,947,455.64,955.51Z"
            />
            <path
              class={cls8}
              d="M343,821.47C414.9,838,450,885.06,421.29,926.56a74.43,74.43,0,0,1-6.9,8.55C371.56,921.19,318,921,274.28,936c-25.7-24.12-72.35-39.34-123.26-38.49-.19-10.26,3-20.71,10-30.83,21-30.45,70.48-49.45,123.72-50.88l-29.35,57.8,28,29.62,51.31-16.14-30.75-71A229,229,0,0,1,343,821.47Z"
            />
            <path
              class={cls7}
              d="M414.39,935.11c-10.38,11.1-24.8,20.33-41.76,27.32-.6-3.48-3.2-6.87-7.81-9.52-10.58-6.11-27.76-6.11-38.35,0-5.3,3.05-7.94,7.06-7.94,11.07v12c-7.7.89-15.57,1.4-23.52,1.53a47.9,47.9,0,0,0-1.46-10.76c-2.83-11.26-9.55-21.63-19.27-30.74C318,921,371.56,921.19,414.39,935.11Z"
            />
            <path
              class={cls8}
              d="M372.63,962.43a8.93,8.93,0,0,1,.13,1.55c0,4-2.65,8-7.94,11.07-10.58,6.12-27.76,6.12-38.35,0-5.3-3-7.94-7.06-7.94-11.07s2.64-8,7.94-11.07c10.59-6.11,27.77-6.11,38.35,0C369.43,955.56,372,959,372.63,962.43Z"
            />
            <polygon points="303.92 816.03 334.67 887.06 283.36 903.21 295.04 795.51 303.92 816.03" />
            <path
              class={cls8}
              d="M364.82,975.05c5.29-3,7.94-7.06,7.94-11.07v41.63c0,4-2.65,8-7.94,11.06-10.58,6.12-27.76,6.12-38.35,0-5.29-3-7.94-7-7.94-11.06V964c0,4,2.64,8,7.94,11.07C337.06,981.17,354.24,981.17,364.82,975.05Z"
            />
            <polygon
              class={cls8}
              points="295.04 795.51 283.36 903.21 255.38 873.58 284.74 815.78 295.04 795.51"
            />
            <path
              class={cls7}
              d="M295,977.48c.61,29.33-26.44,56-68.72,70.5-26.73-25-27.21-56-3.89-80.88q8.06,2.61,16.88,4.65A232.93,232.93,0,0,0,295,977.48Z"
            />
            <path d="M295,977.48a232.93,232.93,0,0,1-55.73-5.73q-8.82-2-16.88-4.65c8.81-9.42,21-18,36.47-25,5-2.25,10.12-4.3,15.41-6.11,9.72,9.11,16.44,19.48,19.27,30.74A47.9,47.9,0,0,1,295,977.48Z" />
            <path
              class={cls7}
              d="M274.28,936c-5.29,1.81-10.44,3.86-15.41,6.11-15.46,7-27.66,15.59-36.47,25A158.83,158.83,0,0,1,192,953.78v-15L156,918h0a49.65,49.65,0,0,1-5-20.52C201.93,896.64,248.58,911.86,274.28,936Z"
            />
            <path
              class={cls8}
              d="M192,953.78A158.83,158.83,0,0,0,222.4,967.1c-23.32,24.9-22.84,55.84,3.89,80.88a214.14,214.14,0,0,1-51.23,10.43C98.49,1064.83,27.39,1034.2,16.27,990s41.91-85.25,118.48-91.68q8.19-.69,16.27-.82A49.65,49.65,0,0,0,156,918l-1.11-.65-37.07,21.41v39.59l37.07,21.4L192,978.36Z"
            />
            <polygon points="191.97 953.78 191.97 978.36 154.91 999.76 154.91 960.18 191.97 938.76 191.97 953.78" />
            <polygon
              class={cls8}
              points="191.97 938.76 154.91 960.18 117.84 938.76 154.91 917.36 156.03 918.01 156.04 918.02 191.97 938.76"
            />
            <polygon
              class={cls8}
              points="154.91 960.18 154.91 999.76 117.84 978.36 117.84 938.76 154.91 960.18"
            />
            <path
              class={cls6}
              d="M226.29,1048a214.14,214.14,0,0,1-51.23,10.43C98.49,1064.83,27.39,1034.2,16.27,990s41.91-85.25,118.48-91.68q8.19-.69,16.27-.82c50.91-.85,97.56,14.37,123.26,38.49,9.72,9.11,16.44,19.48,19.27,30.74A47.9,47.9,0,0,1,295,977.48C295.62,1006.81,268.57,1033.53,226.29,1048Z"
            />
            <path
              class={cls6}
              d="M414.39,935.11c15.48,5,29.57,11.85,41.25,20.4,47.93,35.07,37.53,85.93-23.23,113.6s-148.83,21.67-196.76-13.41a100,100,0,0,1-9.36-7.72c-26.73-25-27.21-56-3.89-80.88,8.81-9.42,21-18,36.47-25,5-2.25,10.12-4.3,15.41-6.11C318,921,371.56,921.19,414.39,935.11Z"
            />
            <path
              class={cls6}
              d="M318.53,976c-7.7.89-15.57,1.4-23.52,1.53a232.93,232.93,0,0,1-55.73-5.73q-8.82-2-16.88-4.65A158.83,158.83,0,0,1,192,953.78"
            />
            <path
              class={cls6}
              d="M156,918a49.65,49.65,0,0,1-5-20.52c-.19-10.26,3-20.71,10-30.83,21-30.45,70.48-49.45,123.72-50.88"
            />
            <path
              class={cls6}
              d="M303.92,816A229,229,0,0,1,343,821.47C414.9,838,450,885.06,421.29,926.56a74.43,74.43,0,0,1-6.9,8.55c-10.38,11.1-24.8,20.33-41.76,27.32"
            />
            <polygon
              class={cls6}
              points="191.97 938.76 154.91 960.18 117.84 938.76 154.91 917.36 156.03 918.01 156.04 918.02 191.97 938.76"
            />
            <path
              class={cls6}
              d="M318.53,964c0-4,2.64-8,7.94-11.07,10.59-6.11,27.77-6.11,38.35,0,4.61,2.65,7.21,6,7.81,9.52a8.93,8.93,0,0,1,.13,1.55c0,4-2.65,8-7.94,11.07-10.58,6.12-27.76,6.12-38.35,0C321.17,972,318.53,968,318.53,964Z"
            />
            <path
              class={cls6}
              d="M372.76,964v41.63c0,4-2.65,8-7.94,11.06-10.58,6.12-27.76,6.12-38.35,0-5.29-3-7.94-7-7.94-11.06V964"
            />
            <polyline
              class={cls6}
              points="117.84 938.76 117.84 978.36 154.91 999.76 191.97 978.36 191.97 953.78 191.97 938.76"
            />
            <line
              class={cls6}
              x1="154.91"
              y1="960.18"
              x2="154.91"
              y2="999.76"
            />
            <polyline
              class={cls6}
              points="283.36 903.21 295.04 795.51 303.92 816.03 334.67 887.06 283.36 903.21 255.38 873.58 284.74 815.78 295.04 795.51"
            />
            <polyline
              class={cls6}
              points="136.64 785.38 118.6 803.16 100.56 764.55 82.52 782.33 64.47 743.71 46.42 761.49"
            />
            <polyline
              class={cls6}
              points="1371.53 835.27 1389.57 853.05 1407.62 814.44 1425.66 832.22 1443.7 793.6 1461.75 811.38"
            />
            <path
              class="cls-12"
              d="M37.05,619.32a15.95,15.95,0,1,0-15.94,15.94A15.95,15.95,0,0,0,37.05,619.32Z"
            />
            <path
              class="cls-12"
              d="M959.58,152.27a15.95,15.95,0,1,0-15.94,15.95A15.94,15.94,0,0,0,959.58,152.27Z"
            />
            <path
              class="cls-12"
              d="M1117.2,1178.35a15.95,15.95,0,1,0-16,15.94A15.95,15.95,0,0,0,1117.2,1178.35Z"
            />
            <path d="M1096.15,338.14c6.13,13.2-6.17,26.74-27.77,31.52-1.5.32-3,.61-4.59.85a77.59,77.59,0,0,1-28.29-.85c-13.2-2.94-23.86-9.36-27.79-17.84-6.13-13.19,6.17-26.73,27.79-31.51v16.06c0,2.43,1.59,4.86,4.81,6.72,6.42,3.7,16.83,3.7,23.25,0,3.15-1.83,4.76-4.2,4.82-6.6V320.31C1081.56,323.25,1092.22,329.65,1096.15,338.14Z" />
            <path
              class={cls8}
              d="M1068.38,336.37v.12c-.06,2.4-1.67,4.77-4.82,6.6-6.42,3.7-16.83,3.7-23.25,0-3.22-1.86-4.81-4.29-4.81-6.72V235.44c0,2.42,1.59,4.86,4.81,6.71,6.42,3.69,16.83,3.69,23.25,0,3.15-1.83,4.76-4.21,4.82-6.61V336.37Z"
            />
            <path
              class={cls8}
              d="M1068.38,235.44v.1c-.06,2.4-1.67,4.78-4.82,6.61-6.42,3.69-16.83,3.69-23.25,0-3.22-1.85-4.81-4.29-4.81-6.71s1.59-4.87,4.81-6.72c6.42-3.7,16.83-3.7,23.25,0C1066.78,230.57,1068.38,233,1068.38,235.44Z"
            />
            <path
              class={cls6}
              d="M1068.38,320.31c13.18,2.94,23.84,9.34,27.77,17.83,6.13,13.2-6.17,26.74-27.77,31.52-1.5.32-3,.61-4.59.85a77.59,77.59,0,0,1-28.29-.85c-13.2-2.94-23.86-9.36-27.79-17.84-6.13-13.19,6.17-26.73,27.79-31.51"
            />
            <path
              class={cls6}
              d="M1068.38,235.54c-.06,2.4-1.67,4.78-4.82,6.61-6.42,3.69-16.83,3.69-23.25,0-3.22-1.85-4.81-4.29-4.81-6.71s1.59-4.87,4.81-6.72c6.42-3.7,16.83-3.7,23.25,0,3.22,1.85,4.82,4.29,4.82,6.72"
            />
            <path class={cls6} d="M1068.38,235.44V336.37" />
            <path
              class={cls6}
              d="M1068.38,336.49c-.06,2.4-1.67,4.77-4.82,6.6-6.42,3.7-16.83,3.7-23.25,0-3.22-1.86-4.81-4.29-4.81-6.72V235.44"
            />
            <path
              class={cls8}
              d="M1348.84,487.75c0,12.43-3.28,25.85-8.95,38.65a124.29,124.29,0,0,1-8,15.2c-9.14,14.82-21.25,27.6-34.52,35.28-14.22,8.21-27.08,9-36.42,3.61l-.69-.4c-8.91-5.54-14.38-16.92-14.38-32.9,0-32.84,23-72.74,51.49-89.16,13.92-8,26.56-8.94,35.82-3.92l.57.31C1343.08,459.81,1348.84,471.33,1348.84,487.75Z"
            />
            <path d="M1312.41,442.07l20.8,12c-9.26-5-21.9-4.12-35.82,3.92-28.45,16.42-51.49,56.32-51.49,89.16,0,16,5.47,27.36,14.38,32.9l-20.65-11.94c-8.17-4.72-13.6-14.16-14.83-27.45-.17-1.87-.26-3.84-.26-5.87a79,79,0,0,1,1.15-13.21c5-29.68,25.61-61.68,50.33-75.94C1290.24,437.47,1303.09,436.7,1312.41,442.07Z" />
            <path
              class={cls6}
              d="M1333.21,454.11c-9.26-5-21.9-4.12-35.82,3.92-28.45,16.42-51.49,56.32-51.49,89.16,0,16,5.47,27.36,14.38,32.9"
            />
            <path
              class={cls6}
              d="M1261,580.49c9.34,5.37,22.2,4.6,36.42-3.61,13.27-7.68,25.38-20.46,34.52-35.28a124.29,124.29,0,0,0,8-15.2c5.67-12.8,8.95-26.22,8.95-38.65,0-16.42-5.76-27.94-15.06-33.33"
            />
            <path
              class={cls6}
              d="M1333.78,454.42l-.57-.31-20.8-12c-9.32-5.37-22.17-4.6-36.39,3.61-24.72,14.26-45.34,46.26-50.33,75.94a79,79,0,0,0-1.15,13.21c0,2,.09,4,.26,5.87,1.23,13.29,6.66,22.73,14.83,27.45l20.65,11.94.69.4"
            />
            <path d="M1302.48,487.85c4.58-2.08,9.73-3.19,13.83-2.51-3.08,9.23-4,12-4.26,12.79a.06.06,0,0,1,0,0h0a0,0,0,0,1,0,0h0v0a0,0,0,0,1,0,0s0,0,0,0,0,0,0,0h0a.24.24,0,0,0,0,.07c-4.67-.37-10.6.66-14.26,2.77a12.46,12.46,0,0,0-2.38,1.75,6.23,6.23,0,0,0-2.22,4.4c0,6.49,13.74-2.77,20.11.91a6,6,0,0,1,.56.37c5,3.79,3.91,19.61-11.28,30.74v11.15l-8.38,4.84V544.13a28.61,28.61,0,0,1-8.82,2.23,16.76,16.76,0,0,1-7.08-.84l4.48-13c8.18,3.42,21.57-1.83,21.57-8.88,0-4.07-5.13-2.11-10.59-.76-3.52.87-7.17,1.5-9.64.06l-.08,0c-1.81-1.08-3-3.29-3-7.31,0-8.32,5.3-16.81,13.12-22.8V482.06h.05l0,0h0l8.28-4.79v10.64Z" />
            <path
              class={cls9}
              d="M1277.39,1082.13c4.76,10.09.28,21.32-13.45,29.25a54.92,54.92,0,0,1-5.08,2.58c-9.36,4.16-20.59,6.23-31.82,6.23-1.18,0-2.36,0-3.53-.06-12.15-.48-24.07-3.39-33.37-8.75-13.73-7.93-18.2-19.16-13.45-29.25l9.89-23.11,6.1-14.24a12.1,12.1,0,0,0-.67,7.58c1,4.28,4.34,8.4,10,11.67a38.85,38.85,0,0,0,6.46,3,54.92,54.92,0,0,0,16.15,3c.8,0,1.6,0,2.39,0a53.89,53.89,0,0,0,21.56-4.23A35.74,35.74,0,0,0,1252,1064c9.07-5.23,12.18-12.59,9.35-19.29Z"
            />
            <path
              class={cls8}
              d="M1261.39,1044.74c2.83,6.7-.28,14.06-9.35,19.29a35.74,35.74,0,0,1-3.44,1.75A53.89,53.89,0,0,1,1227,1070c-.79,0-1.59,0-2.39,0a54.92,54.92,0,0,1-16.15-3,38.85,38.85,0,0,1-6.46-3c-5.69-3.27-9-7.39-10-11.67a12.1,12.1,0,0,1,.67-7.58l0-.09,9.24-21.6,8.13-19c-1.36,3.28.19,6.9,4.63,9.47a19.35,19.35,0,0,0,3.19,1.45,27.36,27.36,0,0,0,9.13,1.5,25.22,25.22,0,0,0,12.32-3c4.36-2.5,5.93-6,4.73-9.25l17.28,40.39Z"
            />
            <path d="M1244.09,1004.3c1.2,3.24-.37,6.75-4.73,9.25a25.22,25.22,0,0,1-12.32,3,27.36,27.36,0,0,1-9.13-1.5,19.35,19.35,0,0,1-3.19-1.45c-4.44-2.57-6-6.19-4.63-9.47l0-.08,13.76-32.13,3.16-7.4,5.24,12.25L1244,1004Z" />
            <path
              class={cls6}
              d="M1244.09,1004.3c1.2,3.24-.37,6.75-4.73,9.25a25.22,25.22,0,0,1-12.32,3,27.36,27.36,0,0,1-9.13-1.5,19.35,19.35,0,0,1-3.19-1.45c-4.44-2.57-6-6.19-4.63-9.47"
            />
            <path
              class={cls6}
              d="M1261.39,1044.74c2.83,6.7-.28,14.06-9.35,19.29a35.74,35.74,0,0,1-3.44,1.75A53.89,53.89,0,0,1,1227,1070c-.79,0-1.59,0-2.39,0a54.92,54.92,0,0,1-16.15-3,38.85,38.85,0,0,1-6.46-3c-5.69-3.27-9-7.39-10-11.67a12.1,12.1,0,0,1,.67-7.58"
            />
            <path
              class={cls6}
              d="M1232.28,976.72,1227,964.47l-3.16,7.4L1210.12,1004l0,.08-8.13,19-9.24,21.6,0,.09-6.1,14.24-9.89,23.11c-4.75,10.09-.28,21.32,13.45,29.25,9.3,5.36,21.22,8.27,33.37,8.75,1.17,0,2.35.06,3.53.06,11.23,0,22.46-2.07,31.82-6.23a54.92,54.92,0,0,0,5.08-2.58c13.73-7.93,18.21-19.16,13.45-29.25l-16-37.39,0,0-17.28-40.39-.12-.3-11.69-27.28"
            />
            <path
              class={cls6}
              d="M1219.59,303.59c2.88-11.34,7.6-22.58,12.73-19.62,6.66,3.85,4.42,14.84,12.7,19.63,14.69,8.48,19.37-48.51,34.18-40,15.24,8.8,12.38,37.78,20.83,42.65,9.14,5.28,7.64-13.2,14.21-9.4s2.87,20.53,10.14,24.73,6.55-12.61,13.42-8.64c6.13,3.54,13.68,44.22,17.78,69.13"
            />
            <line
              class={cls6}
              x1="470.57"
              y1="179.27"
              x2="500.69"
              y2="161.88"
            />
            <line
              class={cls6}
              x1="500.69"
              y1="179.27"
              x2="470.57"
              y2="161.88"
            />
            <line
              class={cls6}
              x1="1462.15"
              y1="629.88"
              x2="1492.27"
              y2="612.49"
            />
            <line
              class={cls6}
              x1="1492.27"
              y1="629.88"
              x2="1462.15"
              y2="612.49"
            />
            <line
              class={cls6}
              x1="615.22"
              y1="1246.37"
              x2="645.33"
              y2="1228.99"
            />
            <line
              class={cls6}
              x1="645.33"
              y1="1246.37"
              x2="615.22"
              y2="1228.99"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
